import marriott from "../../images/companies/marriott.png";
import hilton from "../../images/companies/hilton.png";
import hyatt from "../../images/companies/hyatt.png";
import wyndham from "../../images/companies/wyndham.png";
import omni from "../../images/companies/omni.png";
import loews from "../../images/companies/loews.png";
import kimpton from "../../images/companies/kimpton.png";
import four_seasons from "../../images/companies/four-seasons.png";

const sharedResponsibilities = [
  "Deliver thoughtful, timely service that supports an excellent guest experience.",
  "Follow brand, safety, sanitation, and workplace procedures throughout every shift.",
  "Communicate clearly with teammates and supervisors to keep daily operations running smoothly.",
];
const sharedRequirements = [
  "Reliable attendance and a positive, guest-first attitude.",
  "Comfort working on your feet in a fast-paced hospitality environment.",
  "English communication skills; additional languages are welcome.",
];
const sharedBenefits = [
  "Competitive hourly pay with regular performance reviews.",
  "Employee hotel discounts and career development resources.",
  "Medical, dental, and retirement eligibility for qualifying team members.",
];
const makeJob = (
  id,
  title,
  company,
  companyCode,
  logo,
  city,
  state,
  type,
  level,
  salary,
  salaryMin,
  category,
  postedDays,
  featured = false,
  titleKey,
) => {
  const salaryValues = salary.match(/\d+(?:\.\d+)?/g)?.map(Number) || [];

  return {
    id,
    title,
    titleKey,
    company,
    companyCode,
    logo,
    city,
    state,
    location: `${city}, ${state}, USA`,
    type,
    level,
    salary,
    salaryCurrency: "USD",
    salaryMin,
    salaryMax: salaryValues[1] ?? salaryMin,
    salaryHasTips: salary.toLowerCase().includes("tips"),
    category,
    postedDays,
    featured,
    description: `Join the ${company} team and help create a welcoming, dependable experience for every guest. This role offers structured onboarding, supportive leadership, and room to grow in hospitality.`,
    responsibilities: sharedResponsibilities,
    requirements: sharedRequirements,
    benefits: sharedBenefits,
  };
};

export const jobs = [
  makeJob(
    1,
    "Hotel Housekeeper",
    "Marriott International",
    "marriott",
    marriott,
    "New York",
    "NY",
    "Full Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Housekeeping",
    1,
    true,
  ),
  makeJob(
    2,
    "Front Desk Agent",
    "Hilton",
    "hilton",
    hilton,
    "Miami",
    "FL",
    "Full Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Front Desk",
    2,
    true,
  ),
  makeJob(
    3,
    "Kitchen Assistant",
    "Hyatt",
    "hyatt",
    hyatt,
    "Chicago",
    "IL",
    "Full Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Food & Beverage",
    1,
    true,
  ),
  makeJob(
    4,
    "Hotel Cleaner",
    "Wyndham Hotels & Resorts",
    "wyndham",
    wyndham,
    "Orlando",
    "FL",
    "Part Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Housekeeping",
    3,
    true,
  ),
  makeJob(
    5,
    "Restaurant Cashier",
    "Marriott International",
    "marriott",
    marriott,
    "Los Angeles",
    "CA",
    "Part Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Food & Beverage",
    4,
  ),
  makeJob(
    6,
    "Laundry Worker",
    "Hilton",
    "hilton",
    hilton,
    "Las Vegas",
    "NV",
    "Full Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Housekeeping",
    2,
  ),
  makeJob(
    7,
    "Maintenance Worker",
    "Hyatt",
    "hyatt",
    hyatt,
    "Austin",
    "TX",
    "Full Time",
    "Experienced",
    "$65-$120/hour",
    65,
    "Maintenance",
    5,
  ),
  makeJob(
    8,
    "Night Janitor",
    "Wyndham Hotels & Resorts",
    "wyndham",
    wyndham,
    "Phoenix",
    "AZ",
    "Full Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Maintenance",
    3,
  ),
  makeJob(
    9,
    "Restaurant Server",
    "Omni Hotels & Resorts",
    "other",
    omni,
    "Dallas",
    "TX",
    "Part Time",
    "Entry Level",
    "$65-$120/hour + tips",
    65,
    "Food & Beverage",
    1,
  ),
  makeJob(
    10,
    "Guest Services Associate",
    "Marriott International",
    "marriott",
    marriott,
    "Seattle",
    "WA",
    "Full Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Guest Services",
    6,
  ),
  makeJob(
    11,
    "Room Attendant",
    "Hilton",
    "hilton",
    hilton,
    "Boston",
    "MA",
    "Full Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Housekeeping",
    1,
    true,
  ),
  makeJob(
    12,
    "Banquet Setup Attendant",
    "Hyatt",
    "hyatt",
    hyatt,
    "Denver",
    "CO",
    "Part Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Events",
    7,
  ),
  makeJob(
    13,
    "Breakfast Attendant",
    "Wyndham Hotels & Resorts",
    "wyndham",
    wyndham,
    "Nashville",
    "TN",
    "Part Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Food & Beverage",
    2,
  ),
  makeJob(
    14,
    "Hotel Security Officer",
    "Loews Hotels",
    "other",
    loews,
    "New Orleans",
    "LA",
    "Full Time",
    "Experienced",
    "$65-$120/hour",
    65,
    "Security",
    8,
  ),
  makeJob(
    15,
    "Public Area Cleaner",
    "Marriott International",
    "marriott",
    marriott,
    "San Diego",
    "CA",
    "Full Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Housekeeping",
    4,
  ),
  makeJob(
    16,
    "Bell Attendant",
    "Hilton",
    "hilton",
    hilton,
    "Washington",
    "DC",
    "Full Time",
    "Entry Level",
    "$65-$120/hour + tips",
    65,
    "Guest Services",
    3,
  ),
  makeJob(
    17,
    "Dishwasher",
    "Hyatt",
    "hyatt",
    hyatt,
    "San Francisco",
    "CA",
    "Full Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Food & Beverage",
    5,
  ),
  makeJob(
    18,
    "Hotel Maintenance Technician",
    "Wyndham Hotels & Resorts",
    "wyndham",
    wyndham,
    "Atlanta",
    "GA",
    "Full Time",
    "Experienced",
    "$65-$120/hour",
    65,
    "Maintenance",
    2,
  ),
  makeJob(
    19,
    "Reservations Agent",
    "Marriott International",
    "marriott",
    marriott,
    "Salt Lake City",
    "UT",
    "Full Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Front Desk",
    9,
  ),
  makeJob(
    20,
    "Coffee Bar Attendant",
    "Hilton",
    "hilton",
    hilton,
    "Portland",
    "OR",
    "Part Time",
    "Entry Level",
    "$65-$120/hour + tips",
    65,
    "Food & Beverage",
    3,
  ),
  makeJob(
    21,
    "Housekeeping Supervisor",
    "Hyatt",
    "hyatt",
    hyatt,
    "Houston",
    "TX",
    "Full Time",
    "Experienced",
    "$65-$120/hour",
    65,
    "Housekeeping",
    6,
  ),
  makeJob(
    22,
    "Pool Attendant",
    "Wyndham Hotels & Resorts",
    "wyndham",
    wyndham,
    "Tampa",
    "FL",
    "Part Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Guest Services",
    1,
  ),
  makeJob(
    23,
    "Valet Parking Attendant",
    "Kimpton Hotels",
    "other",
    kimpton,
    "Philadelphia",
    "PA",
    "Part Time",
    "Entry Level",
    "$65-$120/hour + tips",
    65,
    "Guest Services",
    7,
  ),
  makeJob(
    24,
    "General Hospitality Staff",
    "Marriott International",
    "marriott",
    marriott,
    "Charlotte",
    "NC",
    "Full Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Guest Services",
    2,
  ),
  makeJob(
    25,
    "Stewarding Associate",
    "Hilton",
    "hilton",
    hilton,
    "Honolulu",
    "HI",
    "Full Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Food & Beverage",
    4,
  ),
  makeJob(
    26,
    "Event Services Assistant",
    "Hyatt",
    "hyatt",
    hyatt,
    "Baltimore",
    "MD",
    "Part Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Events",
    3,
  ),
  makeJob(
    27,
    "Lobby Ambassador",
    "Wyndham Hotels & Resorts",
    "wyndham",
    wyndham,
    "Savannah",
    "GA",
    "Full Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Guest Services",
    5,
  ),
  makeJob(
    28,
    "Receiving Clerk",
    "Four Seasons Hotels",
    "other",
    four_seasons,
    "Scottsdale",
    "AZ",
    "Full Time",
    "Experienced",
    "$65-$120/hour",
    65,
    "Operations",
    6,
  ),
  makeJob(
    29,
    "Hotel Housekeeper",
    "Omni Hotels & Resorts",
    "other",
    omni,
    "Dallas",
    "TX",
    "Full Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Housekeeping",
    2,
    false,
    1,
  ),
  makeJob(
    30,
    "Front Desk Agent",
    "Omni Hotels & Resorts",
    "other",
    omni,
    "Dallas",
    "TX",
    "Full Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Front Desk",
    3,
    false,
    2,
  ),
  makeJob(
    31,
    "Kitchen Assistant",
    "Omni Hotels & Resorts",
    "other",
    omni,
    "Austin",
    "TX",
    "Full Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Food & Beverage",
    5,
    false,
    3,
  ),
  makeJob(
    32,
    "Banquet Setup Attendant",
    "Omni Hotels & Resorts",
    "other",
    omni,
    "Dallas",
    "TX",
    "Part Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Events",
    4,
    false,
    12,
  ),
  makeJob(
    33,
    "Reservations Agent",
    "Omni Hotels & Resorts",
    "other",
    omni,
    "Boston",
    "MA",
    "Full Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Front Desk",
    6,
    false,
    19,
  ),
  makeJob(
    34,
    "Hotel Housekeeper",
    "Loews Hotels",
    "other",
    loews,
    "New Orleans",
    "LA",
    "Full Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Housekeeping",
    2,
    false,
    1,
  ),
  makeJob(
    35,
    "Front Desk Agent",
    "Loews Hotels",
    "other",
    loews,
    "New Orleans",
    "LA",
    "Full Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Front Desk",
    4,
    false,
    2,
  ),
  makeJob(
    36,
    "Restaurant Cashier",
    "Loews Hotels",
    "other",
    loews,
    "Orlando",
    "FL",
    "Part Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Food & Beverage",
    5,
    false,
    5,
  ),
  makeJob(
    37,
    "Maintenance Worker",
    "Loews Hotels",
    "other",
    loews,
    "New Orleans",
    "LA",
    "Full Time",
    "Experienced",
    "$65-$120/hour",
    65,
    "Maintenance",
    3,
    false,
    7,
  ),
  makeJob(
    38,
    "Event Services Assistant",
    "Loews Hotels",
    "other",
    loews,
    "Miami",
    "FL",
    "Part Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Events",
    7,
    false,
    26,
  ),
  makeJob(
    39,
    "Hotel Cleaner",
    "Kimpton Hotels",
    "other",
    kimpton,
    "Philadelphia",
    "PA",
    "Full Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Housekeeping",
    2,
    false,
    4,
  ),
  makeJob(
    40,
    "Guest Services Associate",
    "Kimpton Hotels",
    "other",
    kimpton,
    "Austin",
    "TX",
    "Full Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Guest Services",
    4,
    false,
    10,
  ),
  makeJob(
    41,
    "Room Attendant",
    "Kimpton Hotels",
    "other",
    kimpton,
    "Philadelphia",
    "PA",
    "Part Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Housekeeping",
    3,
    false,
    11,
  ),
  makeJob(
    42,
    "Restaurant Server",
    "Kimpton Hotels",
    "other",
    kimpton,
    "San Francisco",
    "CA",
    "Part Time",
    "Entry Level",
    "$65-$120/hour + tips",
    65,
    "Food & Beverage",
    1,
    false,
    9,
  ),
  makeJob(
    43,
    "Reservations Agent",
    "Kimpton Hotels",
    "other",
    kimpton,
    "Austin",
    "TX",
    "Full Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Front Desk",
    6,
    false,
    19,
  ),
  makeJob(
    44,
    "Housekeeping Supervisor",
    "Four Seasons Hotels",
    "other",
    four_seasons,
    "Scottsdale",
    "AZ",
    "Full Time",
    "Experienced",
    "$65-$120/hour",
    65,
    "Housekeeping",
    2,
    false,
    21,
  ),
  makeJob(
    45,
    "Front Desk Agent",
    "Four Seasons Hotels",
    "other",
    four_seasons,
    "New York",
    "NY",
    "Full Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Front Desk",
    3,
    false,
    2,
  ),
  makeJob(
    46,
    "Kitchen Assistant",
    "Four Seasons Hotels",
    "other",
    four_seasons,
    "Scottsdale",
    "AZ",
    "Full Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Food & Beverage",
    5,
    false,
    3,
  ),
  makeJob(
    47,
    "Guest Services Associate",
    "Four Seasons Hotels",
    "other",
    four_seasons,
    "Boston",
    "MA",
    "Full Time",
    "Entry Level",
    "$65-$120/hour",
    65,
    "Guest Services",
    4,
    false,
    10,
  ),
  makeJob(
    48,
    "Hotel Maintenance Technician",
    "Four Seasons Hotels",
    "other",
    four_seasons,
    "Scottsdale",
    "AZ",
    "Full Time",
    "Experienced",
    "$65-$120/hour",
    65,
    "Maintenance",
    7,
    false,
    18,
  ),
];
